import { Box } from "@chakra-ui/layout";
import NewTable from "ui/components/NewTable";
import PageHeader from "ui/components/Page/PageHeader";
import usePostagens from "core/features/mural/hooks/usePostagens";
import { PostagemItem } from "core/features/mural/typings";
import { useState } from "react";
import useListagemPostagensColumns from "../../hooks/useListagemPostagensColumns";
import history from "infra/helpers/history";
import useDeletePost from "core/features/mural/hooks/useDeletePost";
import { showConfirm } from "infra/helpers/alerta";
import { showErrorAxios } from "infra/helpers/alerta";
import { useLoading } from "ui/components/GlobalLoading";

function ListaPostagens() {
    const [page, setPage] = useState<number>(1);
    const { data, isLoading, refetch } = usePostagens({ page });

    const columns = useListagemPostagensColumns({
        onToogled: () => {
          refetch();
        },
    });

    const { mutate: handleDelete, isLoading: isLoadingDelete } =
    useDeletePost();

    const handleDeleteConfirm = async (id: any) => {
        const { isConfirmed } = await showConfirm(
            "Deseja realmente confirmar a autorização?"
        );
    
        if (isConfirmed) {
            handleDelete(id, {
                onSuccess: () => refetch(),
                onError: (err) => {
                    showErrorAxios(
                        err,
                    );
                }
            });
        }
    }

    useLoading(isLoadingDelete || isLoading)

    return(
        <>
            <PageHeader
                title="Mural"
                titleButton="Nova publicação"
                onClick={() => history.push(`/administracao/mural/criar`)}
                mb="0px"
            />

            <Box mt="40px">
                <NewTable<PostagemItem>
                    loading={isLoading}
                    columns={columns}
                    dataSource={data?.items ?? []}
                    customPagination={{
                        currentPage: data?.meta.currentPage ?? 0,
                        itemsPerPage: data?.meta.itemsPerPage ?? 0,
                        totalItems: data?.meta.totalItems ?? 0,
                        onChangePage: (p) => setPage(p),
                    }}
                    actions={[
                        {
                        title: "Editar",
                        onClick: (item) =>  history.push(`/administracao/mural/${item.id}`),
                        },                   
                        {
                        title: "Excluir",
                        onClick: (item) =>
                            handleDeleteConfirm(item.id)
                        },                  
                    ]}
                />
            </Box>
        </>
    )
}

export default ListaPostagens;